var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1105 0 0 1.1105 -.21558 -2.436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.9863 20.02v-14.04h7.0198v2.0056c0 0.55457 0.44815 1.0028 1.0028 1.0028h2.0056v11.031zm12.021-12.096c-0.0051-0.088252-0.02215-0.1745-0.05021-0.25873-0.011-0.033099-0.02002-0.064179-0.03413-0.094275-0.049072-0.10729-0.11028-0.20758-0.19643-0.29382l-3.0086-3.0085c-0.08615-0.08625-0.18642-0.14743-0.29275-0.19556-0.03118-0.015048-0.06317-0.024073-0.09633-0.035101-0.08319-0.028077-0.16853-0.044126-0.25566-0.050149-0.02215-1e-3 -0.04217-0.013029-0.06416-0.013029h-9.0255c-0.55457 0-1.0028 0.44827-1.0028 1.0028v16.045c0 0.55449 0.44825 1.0028 1.0028 1.0028h12.034c0.55449 0 1.0028-0.44832 1.0028-1.0028v-13.037c0-0.021054-0.01099-0.040105-0.01296-0.062161z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeWidth: 0.90052
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.154 16.327c-0.18756 0-0.37529-0.07007-0.52085-0.20988l-1.4101-1.3538c-0.29973-0.28766-0.30949-0.76371-0.021809-1.0632 0.28768-0.29964 0.76376-0.31047 1.0635-0.021662l0.87389 0.83887 2.5813-2.6285c0.29111-0.29636 0.76683-0.30096 1.0635-0.0095 0.29636 0.29111 0.30096 0.76716 0.0098 1.0635l-3.1024 3.1589c-0.14752 0.14999-0.34198 0.22531-0.53677 0.22531z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeWidth: 0.90052
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileOn);
export default __webpack_public_path__ + "static/media/file_on.e9265ca5edf9d339e6bb92bfe3da542a.svg";
export { ForwardRef as ReactComponent };